import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { MaintenanceService } from './maintenance.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {

  constructor(private maintenanceService: MaintenanceService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Evita recursão sobre o próprio endpoint de status
    if (req.url.includes('maintenance/status')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const phase = event.headers.get('X-Maintenance-Phase');
          if (phase) this.maintenanceService.updatePhaseFromHeader(phase);
        }
      }),
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          const phase = error.headers?.get('X-Maintenance-Phase');
          if (phase) this.maintenanceService.updatePhaseFromHeader(phase);
          if (error.status === 503) this.maintenanceService.forceCheck();
        }
        // Não engole o erro: handlers existentes continuam funcionando
        return throwError(() => error);
      }),
    );
  }
}
